export const mainClass = 'animate__animated animate__faster';
export const ANIM_CL = {
  zoomIn: 'animate__zoomIn',
  zoomOut: 'animate__zoomOut',
  fadeIn: 'animate__fadeIn',
  fadeOut: 'animate__fadeIn',
  fadeFromTop: 'animate__fadeInDown',
  fadeOutTop: 'animate__fadeOutUp',
  fadeFromLeft: 'animate__fadeInLeft',
  fadeFromRight: 'animate__fadeInRight',
  fadeOutLeft: 'animate__fadeOutLeft',
  fadeOutRight: 'animate__fadeOutRight',
  slideInLeft: 'animate__slideInLeft',
  slideOutLeft: 'animate__slideOutLeft',
};

export const AnimatedClasses = {
  fadeIn: mainClass + ' ' + ANIM_CL.fadeIn,
  fadeOut: mainClass + ' ' + ANIM_CL.fadeOut,
  fadeFromBottom: mainClass + ' animate__fadeInUp',
  fadeFromTop: mainClass + ' ' + ANIM_CL.fadeFromTop,
  fadeFromRight: mainClass + ' ' + ANIM_CL.fadeFromRight,
  fadeFromLeft: mainClass + ' ' + ANIM_CL.fadeFromLeft,
  fadeOutLeft: mainClass + ' ' + ANIM_CL.fadeOutLeft,
  fadeOutTop: mainClass + ' ' + ANIM_CL.fadeOutTop,
  fadeOutRight: mainClass + ' ' + ANIM_CL.fadeOutRight,
  bounceIn: mainClass + ' animate__bounceIn',
  zoomIn: mainClass + ' ' + ANIM_CL.zoomIn,
  slideInLeft: mainClass + ' ' + ANIM_CL.slideInLeft,
  slideOutLeft: mainClass + ' ' + ANIM_CL.slideOutLeft,
  zoomOut: mainClass + ' ' + ANIM_CL.zoomOut,
};

export const SelectClasses = {
  in: 'animate__zoomIn',
  out: 'animate__zoomOut',
};
